import { Component, Input, OnInit } from '@angular/core';
import { ApplicantForm } from '../../forms/applicant.form';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective } from 'ngx-mask';
import { ValidationErrorsComponent } from '../../../../../../../common/validation-errors/validation-errors.component';

@Component({
  selector: 'app-applicant-pesel-data-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgxMaskDirective,
    ValidationErrorsComponent
  ],
  templateUrl: './applicant-pesel-data-form.component.html'
})
export class ApplicantPeselDataFormComponent implements OnInit {
  @Input()
  public form: ApplicantForm | undefined;

  public ngOnInit(): void {
    this.form?.nip.disable();

    this.form?.firstName.enable();
    this.form?.lastName.enable();

    this.form?.name.disable();

    this.form?.fatherName.disable();
    this.form?.motherName.disable();
    this.form?.birthDate.disable();

    this.form?.pesel.enable();

    this.form?.regon.enable();
    this.form?.regon.setValidators([]);
  }
}
